import type { PickerDisplayCategory } from '~/scopes/product-core/components/presentationals/CustomizationFunnelCondensed/CustomizationFunnelCondensed.types'
import {
  LAPTOP_CATEGORIES,
  MACBOOKS_CATEGORIES,
  ProductCategory,
} from '~/scopes/product-core/constants'

const SMARTPHONES_CATEGORIES = [ProductCategory.SMARTPHONE]

const TABLETS_CATEGORIES = [ProductCategory.IPAD, ProductCategory.TABLETS]

/**
 * Resolves a concrete product category id to its condensed-funnel device
 * column. Returns undefined when the category is out of scope for the
 * condensed funnel experiment (not smartphone/macbook/laptop/tablet).
 *
 * @see https://backmarket.atlassian.net/wiki/spaces/BRO/pages/6455231187/Q3+2026+Condensed+M+M+funnel#Picker-logic-by-category
 */
export function getCondensedFunnelCategory(
  categoryId: string,
): PickerDisplayCategory | undefined {
  if (SMARTPHONES_CATEGORIES.includes(categoryId)) {
    return 'SMARTPHONE'
  }
  if (MACBOOKS_CATEGORIES.includes(categoryId)) {
    return 'MACBOOK'
  }
  if (LAPTOP_CATEGORIES.includes(categoryId)) {
    return 'LAPTOP'
  }
  if (TABLETS_CATEGORIES.includes(categoryId)) {
    return 'TABLET'
  }
  return undefined
}
